<template>
  <mu-appbar style='position:fixed;top:0;left:0;z-index:1001;'>
    <mu-list-item solt="left" disabled >
      <mu-avatar backgroundColor="blue" class="user-img" src="../../../../static/images/logo_white.png" slot="leftAvatar"/>
      <span v-html="gName" class="logo"></span>
    </mu-list-item>
    <mu-list-item v-show="showCount" class="divier" slot="right"></mu-list-item>
    <mu-list-item v-show="showCount" titleClass="online-serve" @click="toCount" slot="right">
      <allTrainTimes></allTrainTimes>
    </mu-list-item>
    <mu-list-item class="divier" slot="right"></mu-list-item>
    <mu-list-item id="zhichiBtnBox" class="zhiCustomBtn" titleClass="online-serve"  slot="right"  style="padding:0px;margin:0px;">
     <a href="http://www.sobot.com/chat/pc_new/index.html?sysNum=a523d1984e4c4b24b485096788a3ee81&color=09aeb0&lan=c" target="_black">
        <span>在线客服</span>
     </a>
    </mu-list-item>
    <mu-list-item class="divier" slot="right"></mu-list-item>
    <mu-list-item @click="openMenu" titleClass="login-user" :title="store.account.name" slot="right">
      <mu-avatar :src="imgPath" onerror="this.src='/public/image/patient.png';this.onerror=null;" slot="leftAvatar"/>
      <mu-icon-menu :open="showMenu" @close="closeMenu"
      icon="more_vert" iconClass="iconClass" slot="right">
        <mu-menu-item  title="账户信息" @click="toSet"/>
        <!-- <mu-menu-item  title="使用反馈" @click="tellMe"/> -->
        <a style="display:block;width:112px;height:48px;line-height:48px;color:#444;font-size:16px;padding:0 16px;" href="http://jsform3.com/f/5a798446e7aea961dad8abb0" target="_black">使用反馈</a>
        <mu-menu-item  title="更新日志" @click="seeLog"/>
        <mu-menu-item title="退出" @click="logout"/>
      </mu-icon-menu>
    </mu-list-item>
  </mu-appbar>
</template>

<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  import allTrainTimes from '../../common/timer/allTrainTimes.vue'

  export default({
    data () {
      return {
        username: '',
        // gName: GLOBAL.NAME ,
        gName: `六六脑<sup>&#174;</sup>&nbsp;&nbsp;${window.g_system_preferences.name}`,
        store: require('../../../app/store.js'),
        showMenu: false,
        count:500,//训练次数
      }
    },
    computed:{
      imgPath:function(){
		    var k = Math.random();
        var v = Math.random();
        return GLOBAL.avator +'/'+ this.store.account.path+'?' + k + '=' + v;
      },
      showCount: function(){
        return this.$store.state.showCount;
      }
    },
    components: {
      allTrainTimes
    },
    methods: {
      openMenu(){
        this.showMenu = !this.showMenu;
        console.log(this.showMenu)
      },
      closeMenu(){
        this.showMenu = false;
      },
      toSet() {
        this.$router.push({name:'userSet'})
      },
      tellMe(){
        window.open(GLOBAL.TELLME,'_blank');
      },
      seeLog(){
        window.open('/#/seelog');
      },
      logout() {
        this.$http.get('/api/Auth/logout')
        .then((res)=>{
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          this.$router.push({ path: '/login' });
        },(err)=>{
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          this.$router.push({ path: '/login' });
        });
      },
      toCount(){
        this.$router.push({name:"timeList"});
      }
    }
  })
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">

  html {
    padding: 0;
  }
  .zhiCustomBtn a {
    margin -16px
    min-width 140px
    height 50px
    background url('../../../assets/img/icon_kf.png') no-repeat;
    background-position 15% 59%;
    font-family PingFangTC-Regular;
    font-size  16px;
    color #FFFFFF;
    position relative;
    display inline-block;
  }
  .zhiCustomBtn a span {
    position absolute
    top 50%
    left 40%
    transform translateY(-40%)
  }
  .user-img {
    margin-top: 20px;
  }
  .logo {
    color: #fff;
    padding: 0;
  }
  .login-user {
    color: #fff;
    margin-left: 30px;
    margin-right: 30px;
  }
  .online-serve {
    color: #fff;
  }
  .divier {
    width: 2px;
    border-left: 1px solid #eee;
    opacity: 0.2;
  }
  .iconClass {
    color: #fff;
    margin-top: 3px;
  }
  .menuListClass {
    margin-top: 30px;
    width: 120px;
  }
  .count-wrapper{
    position:relative;
  }
  .bubble{
    position:absolute;
    top:12px;
    right:38px;
    width:28px;
    height:12px;
    border-radius:8px;
    background-color:#E75710;
  }
  .count{
    position:absolute;
    top:-2px;
    left:4px;
    color:#fff;
    font-size:12px;
  }
</style>



// WEBPACK FOOTER //
// topmenu.vue?3a102606